<div class="pt-3 pl-md-4" *ngIf="notFound">
  <h2>Custom inbox not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingCustomInbox">
  <h2>Loading Custom Inbox...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewCustomInbox ? 'create custom inboxes' : 'edit this custom inbox' }}.
  </h2>
</div>

<div *ngIf="(serverError === null) && !notFound && !loadingExistingCustomInbox && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/admin/custom-inboxes" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
    </ul>

    <form class="form-inline">
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="loadingSubmit" [disabled]="loadingSubmit"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5 mb-6">
      <h2>
        {{ isNewCustomInbox ? 'New Custom Inbox' : 'Edit Custom Inbox' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="nameInput">
                    Name
                  </label>
                  <input id="nameInput" type="text" name="name"
                         class="form-control"
                         [(ngModel)]="customInbox.name"
                         (ngModelChange)="unsavedChanges = true">
                </div>
              </div>
              <div class="form-text text-danger">{{ errors.name }}</div>
            </div>

            <div class="form-group row">
              <div class="col-lg-6 col-md-8">
                <label for="statusSelect">Status</label>
                <select id="statusSelect" name="status"
                        class="custom-select"
                        [(ngModel)]="customInbox.status"
                        (ngModelChange)="unsavedChanges = true">
                  <option *ngFor="let status of getAvailableStatuses()"
                          [ngValue]="status">
                    {{ getCustomInboxStatusDisplay(status) }}
                  </option>
                </select>
                <small class="form-text text-muted">
                  Once a custom inbox is set to Active (or Retired), it may not be reverted to Draft.
                </small>
                <div class="alert alert-warning mt-2"
                     *ngIf="(existingStatus === CustomInboxStatus.active) && (customInbox.status === CustomInboxStatus.retired)">
                  When this inbox's status is changed to Retired, all existing items in the inbox will be automatically resolved.
                </div>
                <div class="form-text text-danger">{{ errors.status }}</div>
              </div>
            </div>

            <div class="form-group">
              <label>Conditions</label>

              <ng-container *ngIf="isLoadingConditionParameterQueries()">
                <p *ngIf="customInbox.conditions.length === 0"
                 class="text-muted mb-2">
                  Loading...
                </p>
              </ng-container>

              <ng-container *ngIf="!isLoadingConditionParameterQueries()">

                <table *ngIf="customInbox.conditions.length > 0"
                       class="table table-sm mb-2">
                  <tbody>
                    <tr *ngFor="let condition of customInbox.conditions; let conditionIdx = index;">
                      <td>{{ getCustomInboxConditionDescription(condition) }}</td>
                      <td class="text-right table-sm-button-cell text-nowrap">
                        <button class="btn btn-danger btn-sm table-sm-button mr-1"
                                type="button"
                                (click)="removeCondition(conditionIdx)">
                          Remove
                        </button>
                        <button class="btn btn-primary btn-sm table-sm-button"
                                type="button"
                                (click)="editCondition(condition)">
                          Edit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p *ngIf="customInbox.conditions.length === 0"
                   class="text-muted mb-2">
                  No conditions have been selected.
                </p>

                <button class="btn btn-sm btn-link pl-0 mb-2"
                        type="button"
                        (click)="addCondition()">
                  + Add New Condition
                </button>

              </ng-container>

              <small class="d-block text-muted">
                A customer is added to the inbox when they meet these conditions. At least one condition must be provided.
              </small>
            </div>

            <div class="form-group">
              <label for="auto_resolve_time_hours">Auto-Resolve Time (optional)</label>
              <div class="row">
                <div class="col-lg-4 col-md-5 col-sm-6">
                  <div class="input-group">
                    <input id="auto_resolve_time_hours" type="number"
                           name="auto_resolve_time_hours"
                           min="1" step="1"
                           class="form-control"
                           [(ngModel)]="customInbox.auto_resolve_time_hours"
                           (ngModelChange)="unsavedChanges = true">
                    <div class="input-group-append">
                      <span class="input-group-text">hours</span>
                    </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                The amount of time to wait before automatically resolving items in this inbox. Leave this blank in order to keep items in the inbox until they are manually resolved.
              </small>
              <div class="form-text text-danger">{{ errors.auto_resolve_time_hours }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="include_customer_profile_alert">
                    Show Alert on Customer Profile
                  </label>
                  <select id="include_customer_profile_alert"
                          name="include_customer_profile_alert"
                          class="custom-select"
                          [(ngModel)]="customInbox.include_customer_profile_alert"
                          (ngModelChange)="unsavedChanges = true">
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                  </select>
                </div>
              </div>
              <small class="form-text text-muted">
                If this is set to "Yes", then an alert will be shown on the Customer Profile and Check-In Site for any customer which is in this inbox.
              </small>
              <div class="form-text text-danger">{{ errors.include_customer_profile_alert }}</div>
            </div>

            <div class="indented-subsection"
                 *ngIf="customInbox.include_customer_profile_alert">

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="customer_profile_alert_color_hex">
                      Alert Color
                    </label>
                    <app-color-picker [id]="'customer_profile_alert_color_hex'"
                                      [(content)]="customInbox.customer_profile_alert_color_hex"
                                      (contentChange)="unsavedChanges = true"></app-color-picker>
                  </div>
                </div>
                <div class="form-text text-danger">{{ errors.customer_profile_alert_color_hex }}</div>
              </div>

              <div class="form-group">
                <div class="row">
                  <div class="col-lg-6 col-md-8">
                    <label for="prevent_customer_check_in">
                      Prevent Customer Check-In
                    </label>
                    <select id="prevent_customer_check_in"
                            name="prevent_customer_check_in"
                            class="custom-select"
                            [(ngModel)]="customInbox.prevent_customer_check_in"
                            (ngModelChange)="unsavedChanges = true">
                      <option [ngValue]="true">Yes</option>
                      <option [ngValue]="false">No</option>
                    </select>
                  </div>
                </div>
                <small class="form-text text-muted">
                  If this is set to "Yes", then any customer which is in this inbox will be prevented from checking in until their inbox item is resolved.
                </small>
                <div class="form-text text-danger">{{ errors.prevent_customer_check_in }}</div>
              </div>

            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <!--suppress XmlInvalidId -->
                <label for="staffInstructionTextArea">
                  Staff Instruction Text (optional)
                </label>
                <app-markdown-editor [id]="'staffInstructionTextArea'"
                                     [(content)]="customInbox.staff_instruction_text"
                                     (contentChange)="unsavedChanges = true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This will be shown to staff members when they open an item in this inbox.
                </small>
                <div class="form-text text-danger">{{ errors.staff_instruction_text }}</div>
              </div>
            </div>

          </div>
        </div>

        <!-- Allows inputs to submit when enter is pressed -->
        <button type="submit" class="d-none">Hidden submit button</button>
      </form>
    </div>
  </div>
</div>
